import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastContainerDirective, ToastrService} from 'ngx-toastr';
import {Configuration} from '../lib/core/common/configuration';
import {SettingService} from '../lib/core/common/settings.service';
import {StoreService} from '../lib/core/common/store/store.service';
import {RoutingService} from '../lib/core/common/routing.service';
import {DateUtilService} from '../lib/core/common/utils/date_util.service';
import {HitfluencerUserService} from "../services/user/hitfluencer-user.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit {

  @ViewChild(ToastContainerDirective, {static: true}) toastNotification!: ToastContainerDirective;
  password = 'password';
  show = false;

  constructor(public settings: SettingService,
              public config: Configuration,
              public fb: FormBuilder,
              private toastr: ToastrService,
              private store: StoreService,
              private routing: RoutingService,
              private dateUtilService: DateUtilService,
              private userService: HitfluencerUserService) {
    this.settings.setLoaderType('BallClip');
    if (this.toastNotification) {
      this.toastr.overlayContainer = this.toastNotification;
    }
  }

  submitForm(form: any): void {
    if (form.username && form.password) {
      this.userService.login(form.username, form.password);
    }
  }

  ngAfterViewInit(): void {
    this.controlStatusCode();
  }

  controlStatusCode(): void {
    if (this.settings.getError().code) {
      this.userService.dispatchNoAuthError(this.settings.getError().authCode);
      this.settings.getError().code = null;
    }
  }

  goToRecoverUsername(): void {
    this.goToPage('/recover', 'username');
  }

  goToRecoverPassword(): void {
    this.goToPage('/recover', 'password');
  }

  showPassword(): void {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }

  private goToPage(page, type): void {
    this.store.setObject('recover', type);
    this.routing.navigateTo(page);
  }

}
